import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-ecab63d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white mb-1" }
const _hoisted_2 = { class: "container d-flex flex-nowrap p-3 align-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "me-1 me-lg-5",
  width: "200",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LocalizationSwitcher = _resolveComponent("LocalizationSwitcher")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: '/' }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_LocalizationSwitcher)
    ])
  ]))
}